import React from 'react';
import { useSelector } from 'react-redux';
import CIcon from '@coreui/icons-react';
import { useHistory } from 'react-router-dom';
import { selectChatData, selectChatState } from '../../selectors/chat.selector';
import { CHAT_CONNECTION_STATUS_LABEL, getChatConnectionStatus } from '../../../shared/utils/chat-utils';

interface ChatHeaderProps {
  activeChatId: string;
}

const ChatHeader = (props: ChatHeaderProps) => {
  const {
    activeChatId
  } = props;

  const history = useHistory();

  const chat = useSelector(selectChatData)(activeChatId);
  const customer = chat?.chatInfo?.customer;
  const { connected, connecting, reconnecting } = useSelector(selectChatState) ?? {};

  const connectionStatus = getChatConnectionStatus(!!chat?.subscriptionError, connected, connecting, reconnecting);

  const goBack = () => {
    history.push('/chat');
  };

  return (
    <div className="chat-view-header">
      <div className="back-button position-absolute ml-3">
        <CIcon size="xl" name="cil-arrow-left" onClick={goBack} />
      </div>
      <div className="chat-view-header-mobile">
        <div className="chat-customer-name">
          {customer}
        </div>
        <div className={`chat-connection-status chat-connection-status--${connectionStatus}`}>
          <span className="chat-connection-status-dot" />
          {CHAT_CONNECTION_STATUS_LABEL[connectionStatus]}
        </div>
      </div>
    </div>
  );
};

export default ChatHeader;
